import { useState, useEffect } from 'react';
import { Dimensions } from 'react-native';

interface WindowSize {
    width: number;
    height: number;
}
  
const useWindowSize = (): WindowSize => {
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').height,
    });
    
    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
};

export default useWindowSize;
